/* eslint-disable padding-line-between-statements */
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { ClausesComponentVM } from 'ent-components-platform-react';
import { TranslatorContext } from '@jutro/locale';
import { IntlContext } from 'react-intl';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { LoadSaveService } from 'twia-capability-quoteandbind-residential';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { GatewayEndorsementService as ChangeService } from 'twia-capability-gateway-policychange';
import { GatewayRenewalService as RenewalService} from 'gw-capability-gateway-policyrenewal';
import metadata from './CoveragesAccordion.metadata.json5';
import messages from './CoveragesAccordion.messages'
import styles from './CoveragesAccordion.module.scss'
import AdditionalInsuredCoverage from '../Quote/AdditionalInsuredCoverage/AdditionalInsuredCoverage';
import AdditionalPremisesCoverage from '../Quote/AdditionalPremisesCoverage/AdditionalPremisesCoverage';

function CoveragesAccordion(props) {

    const translator = useContext(TranslatorContext);
    const intlContext = useContext(IntlContext);
    const showAdditionalFieldError = false
    const [submissionVM, setInitialSubmission] = useState(null);
    const authHeader = _.get(useAuthentication(), 'authHeader');
    const viewModelService = useContext(ViewModelServiceContext);
    const isTFPACoverageSummary = true

    const { policyDetailsData,
        lobData_TWIA,
        policyTransactionDetails,
        policyTransactionData } = props;

    let ho205CovPremiumAmount


    useEffect(() => {

       // retrieveSubmission()

    }, [])

    // const retrieveSubmission = () => {
    //     if (authHeader) {
    //         // DE16733
    //         const jobType = _.find(policyTransactionData, (job) => job.displayType === 'Submission')
    //         const quoteID = jobType ? jobType.jobNumber : policyTransactionData[0].jobNumber
    //         const postalCode = _.get(policyDetailsData, 'account.accountHolder.primaryAddress.postalCode')
    //         console.log(policyDetailsData, submissionVM)
    //         const requestData = { quoteID, postalCode }

    //         if (policyDetailsData?.latestBoundPeriod_Ext?.jobType_TFPA === 'PolicyChange') {
    //             const jobNumber = _.get(policyDetailsData, 'latestPeriod.policyNumber')

    //             ChangeService.loadEndorsement(jobNumber, authHeader).then((response) => {
    //                 const responseSubmission = viewModelService.create(
    //                     response,
    //                     'pc',
    //                     'edge.capabilities.policychange.dto.PolicyChangeDataDTO')

    //                 setInitialSubmission(responseSubmission);
    //             })
    //         } else {
    //             LoadSaveService.retrieveSubmission(requestData, authHeader).then((response) => {
    //                 const responseSubmission = viewModelService.create(
    //                     response,
    //                     'pc',
    //                     'edge.capabilities.quote.submission.dto.QuoteDataDTO');

    //                 ho205CovPremiumAmount = _.get(responseSubmission, 'lobData.homeowners_tfpa.coverages.homeOfficeLiabPremium_Ext.value')
    //                 setInitialSubmission(responseSubmission);
    //             })
    //         }
    //     }
    // }

    const policyType = _.get(policyDetailsData, 'lobs.homeOwners_tfpa.dwellingDTO.policyType');

    const hideHO205CoverageSection = useCallback(() => {
        const usage =  _.get(policyDetailsData, 'lobs.homeOwners_tfpa.dwellingDTO.homeDetails.dwellingUsage');
        // DE16381
        return policyType?.code === 'DP2' || (policyType?.code === 'HO6' && usage.code === 'rent');
    }, [submissionVM])

    const getAdditionalCoverages = useCallback(() => {
        const addCov = _.get(policyDetailsData, 'hoCoverages.additionalCoverages') 

        return _.filter(addCov, (cov) => cov.publicID !== 'HO205')
    }, [submissionVM]);

    const getByCovLabel = useCallback(() => {
        const addCov =  _.find(_.get(policyDetailsData, 'hoCoverages.additionalCoverages'), (cov) => cov.publicID === 'HO205')

        if (addCov && addCov.amount && !showAdditionalFieldError) {
            const formatterCurrency = intlContext.formatNumber(addCov.amount.amount, {
                style: 'currency',
                currency: addCov.amount.currency,
                // currencyDisplay: 'code',
            });

            return (<p>{`${translator(messages.ho205PremiumLabel)}`}&nbsp;&nbsp;<b>{`(Premium: ${formatterCurrency})`}</b></p>);
        }

        return translator(messages.ho205PremiumLabel)
    }, [intlContext, showAdditionalFieldError, submissionVM, translator])

    const showAdditionalPremisesTfpa = useCallback(() => {
        const occupancy =  _.get(policyDetailsData, 'lobs.homeOwners_tfpa.dwellingDTO.homeDetails.occupancy');
        if (occupancy) {
            if (occupancy.code === 'tenant' && policyType.code === 'HO6') {
                return false;
            }
        }

        if (policyType) {
            if (policyType.code === 'DP2') {
                return false;
            }
        }

        return true;
    }, [submissionVM, policyType]);

    const showAdditionalPersonsTfpa = useCallback(() => {
        if (policyType?.code === 'DP2') {
            return false;
        }
        return true;
    }, [policyType]);

    // DE16262
    const renderValueField = useCallback((rowData, rowIndex) => (
        <div style={{ 'display': 'flex', 'justify-content': 'end' }}>Premium:&nbsp;&nbsp;<CurrencyField
            id={`creditAmount_${rowIndex}`}
            value={rowData.amount}
            readOnly
        /></div>
    ), []);

    const renderNameField = useCallback((rowData) => <span>{rowData.name}</span>, []);

    // DE16446 
    const renderAddlNameField = useCallback((item) => <span>{item.accountContactDTO.displayName}</span>, []);

    const renderRelationType = (item) => item.relationshipToInsured;

    const renderCoverageType = (item, rowId) => {
        const additionalInsureds =_.get(policyDetailsData, 'hoCoverages.additionalInsureds_Ext');

        const selectedInsured = Array.isArray(additionalInsureds) && additionalInsureds.length > 0 ? additionalInsureds[rowId] : {};

        const coveragesArray = Array.isArray(selectedInsured.coverages) ? selectedInsured.coverages : [];

        const coverage = coveragesArray.length > 0 ? coveragesArray[0] : undefined;

        const termsArray = Array.isArray(coverage?.terms) ? coverage.terms : [];

        const term = termsArray.length > 0 ? termsArray[0] : undefined;

        const chosenTermValue = term ? term.chosenTermValue : undefined;

        return chosenTermValue;
    };

    // DE16447
    const ho5CovData = [{ description:  _.get(policyDetailsData, 'hoCoverages.homeOfficeLiabDesc_Ext'), coverageValue: _.get(policyDetailsData, 'hoCoverages.medPayOthers_Ext') }]

    const renderDescription = (item) => item.description;

    const renderMedicalPayment = (item) => item.coverageValue ? 'INCLUDED' : 'NOT INCLUDED'


    const overrideProps = {
        '@field': {
            labelPosition: 'left',
        },
        sectionICoverages: {
            value:  _.get(policyDetailsData, 'hoCoverages.sectionICoverages_Ext') ,
            visible: !_.isUndefined(policyDetailsData),
            // eslint-disable-next-line no-secrets/no-secrets
            path:  'policyDetailsData.hoCoverages.sectionICoverages_Ext',
            submissionVM,
            showError: false,
            isEditable: false,   //US26839
            showAmount: true,
            showCoverageNameAmount: false,
            isTFPAResidentialSummary: true,
            showAdditionalFieldError
        },
        sectionIICoverages: {
            value:  _.get(policyDetailsData, 'hoCoverages.sectionIICoverages_Ext'),
            visible: !_.isUndefined(policyDetailsData),
            // eslint-disable-next-line no-secrets/no-secrets
            path:  'policyDetailsData.hoCoverages.sectionIICoverages_Ext',
            submissionVM,
            loadingClause: false,
            showError: false,
            isEditable: false,   //US26839
            showAmount: true,
            showCoverageNameAmount: false,
            isTFPAResidentialSummary: true,
            showAdditionalFieldError
        },
        additionalCoverages: {
            value: getAdditionalCoverages(),
            visible: !_.isUndefined(policyDetailsData),
            path: 'policyDetailsData.hoCoverages.additionalCoverages',
            loadingClause: false,
            submissionVM,
            showError: false,
            isEditable: false,   //US26839
            showAmount: true,
            showCoverageNameAmount: false,
            isTFPAResidentialSummary: true,
            showAdditionalFieldError
        },
        exclusionsAndConditions: { // DE16271-Removed labelPosition
            value: _.get(policyDetailsData, 'hoCoverages.exclusions_Ext'),
            visible: !_.isUndefined(policyDetailsData),
            // eslint-disable-next-line no-secrets/no-secrets
            path: 'policyDetailsData.hoCoverages.exclusions_Ext',
            submissionVM,
            loadingClause: false,
            showError: false,
            isEditable: false,   //US26839
            showAmount: true,
            showCoverageNameAmount: false,
            isTFPAResidentialSummary: true,
            showAdditionalFieldError
        },
        premium: {
            visible: true //US26839
        },
        moreAdditionalCovs: {
            visible: isTFPACoverageSummary ? false : !hideHO205CoverageSection()
        },
        ho205Fields: {
            visible:  policyDetailsData?.homeOfficeLiabCoverage_Ext === true ,
            className: isTFPACoverageSummary ? 'covSum' : 'clauseAndTermSpacing', //DE16354
        },
        describeField: {
            readOnly: isTFPACoverageSummary, //DE16354
        },
        medicalPayment: {
            readOnly: isTFPACoverageSummary  //DE16354
        },
        sectionICovPremium: {
            visible: !showAdditionalFieldError && ( 
            _.get(policyDetailsData, 'hoCoverages.sectionICoveragesTotal_Ext') !== undefined),
            value: _.get(policyDetailsData, 'hoCoverages.sectionICoveragesTotal_Ext') 
        },
        sectionIICovPremium: {
            visible: !showAdditionalFieldError && ( 
            _.get(policyDetailsData, 'hoCoverages.sectionIICoveragesTotal_Ext') !== undefined) ,
            value:  _.get(policyDetailsData, 'hoCoverages.sectionIICoveragesTotal_Ext') 
        },
        addCovPremium: {
            visible: !showAdditionalFieldError && (
            _.get(policyDetailsData, 'hoCoverages.additionalCoveragesTotal_Ext') !== undefined),
            value:  _.get(policyDetailsData, 'hoCoverages.additionalCoveragesTotal_Ext') 
        },
        exclCovPremium: {
            visible: !showAdditionalFieldError && (
            _.get(policyDetailsData, 'hoCoverages.exclusionsFeeTotal_Ext') !== undefined) ,
            value:  _.get(policyDetailsData, 'hoCoverages.exclusionsFeeTotal_Ext') 
        },
        premiumSectionI: {
            visible: !showAdditionalFieldError && (
            _.get(policyDetailsData, 'hoCoverages.sectionICoveragesTotal_Ext') !== undefined)
        },
        premiumSectionII: {
            visible: !showAdditionalFieldError && (
            _.get(policyDetailsData, 'hoCoverages.sectionIICoveragesTotal_Ext') !== undefined)
        },
        premiumSectionAdd: {
            visible: !showAdditionalFieldError && (
            _.get(policyDetailsData, 'hoCoverages.additionalCoveragesTotal_Ext') !== undefined) ,
        },
        premiumSectionExclusion: {
            visible: !showAdditionalFieldError && (
            _.get(policyDetailsData, 'hoCoverages.exclusionsFeeTotal_Ext') !== undefined),
        },
        ho205Cov: {
            label: getByCovLabel(),
            readOnly: isTFPACoverageSummary //DE16354
        },
        AddlInsCoverageTable: {
            submissionVM,
            authHeader,
            visible: showAdditionalPersonsTfpa() && !_.isNull(policyDetailsData) && !isTFPACoverageSummary
        },
        AddPrmsCoverageTable: {
            submissionVM,
            visible: showAdditionalPremisesTfpa() && !_.isNull(policyDetailsData) && !isTFPACoverageSummary
        },
        discountSurcharges: {
            data:  _.get(policyDetailsData, 'hoCoverages.discountsSurchargesAndFees_Ext') ,
            visible: isTFPACoverageSummary ? true : !showAdditionalFieldError &&
                true//_.get(offeredQuote, 'premium.total') !== undefined
        },
        discountPremium: {
            value:   _.get(policyDetailsData, 'hoCoverages.discountSurchargeFeeTotal_Ext')
        },
        discountSurchargesTitle: {
            visible: isTFPACoverageSummary ? true : !showAdditionalFieldError &&
                true//_.get(offeredQuote, 'premium.total') !== undefined
        },
        additionalCoveragesTitle: {
            visible:  !_.isEmpty(_.get(policyDetailsData, 'hoCoverages.additionalCoverages'))
        },
        sectionICoveragesTitle: {
            visible:  !_.isEmpty(_.get(policyDetailsData, 'hoCoverages.sectionICoverages_Ext')) 
        },
        sectionIICoveragesTitle: {
            visible:  !_.isEmpty(_.get(policyDetailsData, 'hoCoverages.sectionIICoverages_Ext')) 
        },
        // DE16446
        addlInsuredTitle: {
            visible: isTFPACoverageSummary && (
            _.get(policyDetailsData, 'hoCoverages.additionalInsureds_Ext')?.length > 0)
        },
        additionalInsuredCoveragesTable: {
            data:  _.get(policyDetailsData, 'hoCoverages.additionalInsureds_Ext') ,
            visible: isTFPACoverageSummary && (
            _.get(policyDetailsData, 'hoCoverages.additionalInsureds_Ext')?.length > 0)
        },
        addlInsuredPremium: {
            value:  _.get(policyDetailsData, 'hoCoverages.additionalInsuredsTotal_Ext') 
        },
        // DE1644
        ho205CovTitle: {
            visible: true && !_.isUndefined(ho205CovPremiumAmount)
        },
        ho205CoveragesTable: {
            data: ho5CovData,
            visible: true && !_.isUndefined(ho205CovPremiumAmount)
        },
        ho205CovPremium: {
            value:   _.get(policyDetailsData, 'hoCoverages.homeOfficeLiabPremium_Ext') 
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            clausesComponentVM: ClausesComponentVM,
            AddlInsCoverage: AdditionalInsuredCoverage,
            AddPrmsCoverage: AdditionalPremisesCoverage
        },
        resolveCallbackMap: {
            renderCreditName: renderNameField,
            renderCreditValue: renderValueField,
            renderAddlNameField,
            renderRelationType,
            renderCoverageType,
            renderDescription,
            renderMedicalPayment
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={submissionVM}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

CoveragesAccordion.propTypes = {
    data: PropTypes.shape({}).isRequired,
};

export default CoveragesAccordion;
